import { j as s, c } from "../../utils-BdNIfrGQ.js";
import { D as x } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import { F as e } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import "react";
import { P as d } from "../../Paragraph-Cpgi01iq.js";
import { T as a } from "../../Text-BhLXzYEf.js";
const h = ({
  title: p,
  iconSlot: l,
  textSlot: m,
  contentSlot: t,
  actionSlot: i,
  ...o
}) => /* @__PURE__ */ s.jsxs(e, { className: c("flex-row items-start w-full"), gap: "6", ...o, children: [
  m && /* @__PURE__ */ s.jsx(x, { className: "flex-shrink-0", children: /* @__PURE__ */ s.jsx(a, { children: m }) }),
  l && /* @__PURE__ */ s.jsx(x, { className: "flex-shrink-0", children: l }),
  /* @__PURE__ */ s.jsxs(e, { className: "flex-col w-full", gap: "3", children: [
    /* @__PURE__ */ s.jsx(d, { children: /* @__PURE__ */ s.jsx(a, { fontWeight: "semibold", children: p }) }),
    /* @__PURE__ */ s.jsxs(e, { className: "flex-col text-muted-foreground text-sm", gap: "3", children: [
      t.map(
        (r, f) => typeof r == "string" ? /* @__PURE__ */ s.jsx(a, { children: r }, f) : r
      ),
      i && i
    ] })
  ] })
] });
h.displayName = "DisplayItem";
export {
  h as default
};
